

<div class="col-lg-12">
    <div class="dashboard-nav">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item">
                <a class="nav-link" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true" routerLink="/dashboard">Mi Profile</a>
            </li>
           <li class="nav-item">
                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false" routerLink="/upload-cv">Upload CV</a>
            </li>
           <li class="nav-item">
                <a class="nav-link" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true" routerLink="/applied-jobs">Vakaturanan Apliká</a>
            </li> 

            <li class="nav-item">
                <a class="nav-link" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true" routerLink="/change-password">Change Password</a>
            </li> 
           

            <li class="nav-item">
                 </li>
        </ul>
    </div>
</div>
